var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{class:['tag', _vm.type]},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }